/**
 * Từ điển giao diện tiếng Việt — nguồn duy nhất của mọi chuỗi hiển thị (quy tắc 13.1.7).
 * Thêm ngôn ngữ khác: tạo file cạnh file này với kiểu `Messages`, không sửa component.
 *
 * Tham số trong chuỗi viết dạng `{ten}` và được thay bằng `format()` ở `i18n/index.ts`.
 */
export const vi = {
  app: {
    name: 'Paint Online',
    tagline: 'Vẽ, chỉnh ảnh và chú thích ảnh chụp màn hình ngay trong trình duyệt.',
    skipToContent: 'Bỏ qua, tới nội dung chính',
  },

  theme: {
    label: 'Giao diện',
    menuLabel: 'Đổi giao diện sáng/tối',
    system: 'Theo hệ thống',
    light: 'Sáng',
    dark: 'Tối',
    changed: 'Đã chuyển sang giao diện {theme}',
  },

  home: {
    title: 'Bắt đầu nhanh',
    heroTitle: 'Dán ảnh, thả file, hoặc tạo mới',
    heroSubtitle: 'Nhấn {shortcut} để dán ảnh chụp màn hình và chú thích ngay.',
    dropHint: 'Thả ảnh vào đây',
    supportedFormats: 'PNG, JPG, WebP, GIF, BMP',
    privacyNote:
      'Ảnh của bạn không bao giờ rời khỏi máy — mọi xử lý diễn ra ngay trong trình duyệt.',
    openImage: 'Mở ảnh…',
    openImageLabel: 'Mở ảnh từ máy',
    importing: 'Đang mở ảnh…',
    newSection: 'Tạo ảnh mới',
    recentSection: 'Project gần đây',
    recentEmptyTitle: 'Chưa có project nào',
    recentEmptyBody: 'Ảnh bạn mở, dán hoặc tạo mới sẽ hiện ở đây.',
    currentProject: 'Đang mở',
    continueProject: 'Tiếp tục làm việc với {name}',
    pastedName: 'Ảnh dán {time}',
    blankName: 'Ảnh mới {width} × {height}',
    presets: {
      fullHd: { name: 'Full HD', hint: 'Màn hình, slide' },
      square: { name: 'Vuông', hint: 'Mạng xã hội' },
      a4: { name: 'A4 · 150 dpi', hint: 'Giấy in dọc' },
    },
    sizeLabel: '{width} × {height} px',
    createPreset: 'Tạo ảnh mới {name}, {width} × {height} pixel',
    customPreset: { name: 'Tùy chỉnh…', hint: 'Tự nhập kích thước' },
    clipboardPreset: { name: 'Từ clipboard', hint: 'Dán ảnh đã chụp' },
    supportedFormatsWithPaint: 'PNG, JPG, WebP, GIF, BMP · file .paint',
    importingProject: 'Đang nhập project…',
    customSize: {
      title: 'Ảnh mới',
      description: 'Kích thước tính bằng pixel, tối đa {max} px mỗi cạnh.',
      width: 'Rộng',
      height: 'Cao',
      create: 'Tạo',
      cancel: 'Hủy',
      invalid: 'Hãy nhập số nguyên từ 1 đến {max}.',
    },
  },

  projects: {
    searchLabel: 'Tìm project',
    searchPlaceholder: 'Tìm theo tên…',
    sortLabel: 'Sắp xếp',
    sort: {
      updated: 'Mới sửa',
      created: 'Mới tạo',
      name: 'Tên A–Z',
      size: 'Dung lượng',
    },
    count: '{n} project',
    noMatch: 'Không có project nào khớp “{query}”.',
    open: 'Mở',
    openNamed: 'Mở project {name}',
    menuLabel: 'Thao tác với {name}',
    rename: 'Đổi tên…',
    duplicate: 'Nhân bản',
    exportPaint: 'Tải bản sao lưu .paint',
    moveToTrash: 'Chuyển vào thùng rác',
    copyName: '{name} (bản sao)',
    duplicated: 'Đã nhân bản project',
    trashed: 'Đã chuyển “{name}” vào thùng rác',
    restored: 'Đã khôi phục “{name}”',
    purged: 'Đã xóa vĩnh viễn “{name}”',
    trashEmptied: 'Đã dọn thùng rác',
    actionFailed: 'Không thực hiện được thao tác — hãy thử lại.',
    updated: 'Sửa {time}',
    layers: '{n} layer',
    notBackedUp: 'Chưa sao lưu .paint hơn 7 ngày',
    screenshot: 'Ảnh chụp',
    renameTitle: 'Đổi tên project',
    renameLabel: 'Tên project',
    save: 'Lưu',
    cancel: 'Hủy',
    trash: 'Thùng rác',
    trashCount: 'Thùng rác ({n})',
    backToProjects: 'Quay lại danh sách',
    trashHint: 'Project trong thùng rác được xóa vĩnh viễn sau 7 ngày.',
    trashEmpty: 'Thùng rác trống.',
    restore: 'Khôi phục',
    deleteForever: 'Xóa vĩnh viễn',
    emptyTrash: 'Dọn thùng rác',
    daysLeft: 'Còn {n} ngày',
    lastDay: 'Bị xóa hôm nay',
    confirmPurgeTitle: 'Xóa vĩnh viễn “{name}”?',
    confirmPurgeBody: 'Không thể hoàn tác. Hãy tải bản sao lưu .paint trước nếu cần giữ lại.',
    confirmEmptyTitle: 'Dọn thùng rác?',
    confirmEmptyBody: '{n} project sẽ bị xóa vĩnh viễn và không thể hoàn tác.',
    unsavedCard: 'Chưa lưu được',
    unsavedCardHint: 'Project vẫn được giữ trong tab này. Mở lại để thử lưu, hoặc tải .paint.',
    discard: 'Bỏ',
    relative: {
      justNow: 'vừa xong',
      minutes: '{n} phút trước',
      hours: '{n} giờ trước',
      days: '{n} ngày trước',
    },
  },

  storage: {
    statusLabel: 'Trạng thái lưu',
    saved: 'Đã lưu',
    savedAt: 'Đã lưu lúc {time}',
    dirty: 'Có thay đổi chưa lưu',
    saving: 'Đang lưu…',
    error: 'Lỗi lưu',
    quota: 'Hết dung lượng',
    readonly: 'Chỉ đọc',
    unavailable: 'Không lưu tự động',
    retry: 'Thử lại',
    saveNow: 'Lưu ngay',
    savedToast: 'Đã lưu',
    errorReasons: {
      transient: 'Trình duyệt từ chối ghi dữ liệu nhiều lần.',
      encode: 'Không đủ bộ nhớ để mã hóa ảnh. Hãy đóng bớt tab khác rồi thử lại.',
      conflict: 'Một tab khác đã lưu phiên bản mới hơn của project này.',
      missing: 'Project đã bị xóa ở tab khác.',
    },
    errorHint:
      'Dữ liệu vẫn được giữ trong tab này. Đừng đóng tab trước khi lưu được hoặc tải file .paint.',
    unavailableHint:
      'Trình duyệt không cho lưu dữ liệu (có thể do chế độ duyệt riêng tư). Bài vẽ chỉ tồn tại trong tab này — hãy tải file .paint để giữ lại.',
    unavailableBanner:
      'Trình duyệt không cho lưu dữ liệu — app chạy ở chế độ không lưu tự động. Hãy tải file .paint để giữ bài.',
    unavailableImport: 'Không nhập được: trình duyệt không cho lưu dữ liệu.',
    readOnlyBanner: 'Project đang được sửa ở tab khác. Tab này chỉ xem được.',
    takeOver: 'Chỉnh sửa ở tab này',
    takingOver: 'Đang chuyển quyền…',
    takeoverFailed: 'Chưa thể tiếp quản: tab đang chỉnh sửa có thể chưa lưu xong. Hãy thử lại sau.',
    transitionBlocked:
      'Chưa lưu được project hiện tại. Hãy tiếp tục, thử lưu lại hoặc tải .paint; chỉ chọn Bỏ khi muốn bỏ thay đổi.',
    handedOver: 'Đã chuyển quyền chỉnh sửa sang tab khác. Tab này chuyển sang chỉ đọc.',
    lockStolen: 'Tab khác đã lấy quyền chỉnh sửa. Tab này chuyển sang chỉ đọc.',
    openedReadOnly: 'Project đang mở ở tab khác nên tab này chỉ xem được.',
    recovered: 'Phiên trước kết thúc đột ngột — đã khôi phục bản lưu lúc {time}.',
    layersUnreadable: '{n} layer không đọc được nên đã được thay bằng layer trống.',
    discarded: 'Đã đóng “{name}” dù chưa lưu được các thay đổi cuối.',
    lowWarning:
      'Dung lượng lưu trữ sắp đầy. Hãy dọn thùng rác hoặc tải bản sao lưu .paint của project cũ.',
    checkpointsDeleted: 'Đã xóa các bản dự phòng (checkpoint)',
    quotaImport: 'Không đủ dung lượng để nhập project.',
    usage: 'Đã dùng {used} / {quota}',
    usageLabel: 'Dung lượng lưu trữ trong trình duyệt',
    persisted: 'Được bảo vệ khỏi việc trình duyệt tự dọn',
    notPersisted: 'Trình duyệt có thể tự dọn khi thiếu chỗ — hãy sao lưu .paint',
    quotaTitle: 'Hết dung lượng lưu trữ',
    quotaBody:
      'Trình duyệt không còn chỗ để lưu project. Thay đổi mới vẫn nằm trong tab này. Hãy giải phóng dung lượng — app sẽ tự lưu lại khi có chỗ.',
    quotaEmptyTrash: 'Dọn thùng rác',
    quotaDeleteCheckpoints: 'Xóa bản dự phòng (checkpoint)',
    quotaManage: 'Xóa project cũ ở trang chủ',
    quotaDownload: 'Tải file .paint ngay',
    quotaClose: 'Để sau',
    backupReminder: '{n} project đã sửa nhưng chưa sao lưu ra file .paint hơn 7 ngày.',
    backupReminderHint:
      'Dữ liệu chỉ nằm trong trình duyệt này. Dùng menu thao tác của project để tải bản sao lưu.',
    dismiss: 'Ẩn',
  },

  recovery: {
    title: 'Bạn đang làm dở “{name}”',
    uncleanTitle: 'Phiên trước kết thúc đột ngột',
    uncleanBody: 'Đã khôi phục bản lưu của “{name}” lúc {time}.',
    continue: 'Tiếp tục',
    dismiss: 'Bỏ qua',
  },

  projectFile: {
    exportTitle: 'Tải bản sao lưu .paint',
    redactWarningTitle: 'File .paint vẫn chứa ảnh gốc dưới vùng che',
    redactWarningBody:
      'Project có {n} vùng che thông tin (Redact). Vùng che không phá hủy ảnh gốc, nên ai mở file .paint vẫn có thể xóa vùng che để xem nội dung bên dưới.',
    bake: 'Áp dụng vĩnh viễn vùng che trước khi xuất',
    bakeHint:
      'Ghép các layer hiện thành một ảnh; bỏ layer ẩn và dữ liệu gốc có thể khôi phục. Project trong trình duyệt không đổi.',
    keepOriginal: 'Xuất nguyên bản',
    cancel: 'Hủy',
    exportFailed: 'Không xuất được file .paint',
    imported: 'Đã nhập project “{name}”',
    errors: {
      notPaintFile: 'Đây không phải file .paint của Paint Online.',
      tooLarge: 'File .paint quá lớn hoặc có quá nhiều mục.',
      corrupt: 'File .paint bị hỏng hoặc không đọc được.',
      newerVersion: 'File .paint được tạo bởi phiên bản Paint Online mới hơn.',
      invalidManifest: 'Nội dung file .paint không hợp lệ.',
      invalidLayer: 'Ảnh của một layer trong file .paint bị hỏng.',
    },
  },

  exportDialog: {
    title: 'Xuất ảnh',
    description: 'Ảnh xuất ra đã nướng mọi chú thích và vùng che, không mang metadata (EXIF, GPS).',
    format: 'Định dạng',
    formats: { png: 'PNG', jpeg: 'JPG', webp: 'WebP' },
    formatHints: {
      png: 'Không mất chất lượng, giữ nền trong suốt',
      jpeg: 'Nhẹ, hợp với ảnh chụp; không có nền trong suốt',
      webp: 'Nhẹ nhất, giữ nền trong suốt',
    },
    quality: 'Chất lượng',
    scale: 'Tỉ lệ',
    background: 'Màu nền (JPG)',
    outputSize: '{width} × {height} px',
    estimating: 'Đang ước lượng…',
    estimate: '≈ {size}',
    estimateFailed: 'Không ước lượng được',
    preview: 'Xem trước ảnh xuất',
    selectionOnly: 'Chỉ vùng chọn',
    beautify: 'Gồm khung Làm đẹp',
    download: 'Tải xuống',
    cancel: 'Hủy',
  },
  resizeDialog: {
    title: 'Đổi kích thước ảnh',
    description: 'Co giãn mọi layer; chữ và hình chú thích co giãn theo, vẫn sửa được.',
    width: 'Rộng',
    height: 'Cao',
    unit: 'Đơn vị',
    pixels: 'px',
    percent: '%',
    keepRatio: 'Giữ tỉ lệ',
    resample: 'Cách co giãn',
    smooth: 'Mượt (ảnh chụp)',
    pixelated: 'Giữ điểm ảnh (pixel art)',
    result: 'Ảnh mới: {width} × {height} px',
    tooLarge: 'Vượt giới hạn của thiết bị: tối đa {side} px mỗi cạnh và {megapixels} MP.',
    apply: 'Đổi kích thước',
    cancel: 'Hủy',
  },
  canvasDialog: {
    title: 'Kích thước khung',
    description: 'Thêm hoặc bớt vùng quanh ảnh mà không co giãn nội dung.',
    anchor: 'Neo nội dung',
    anchors: {
      nw: 'Trên bên trái',
      n: 'Trên giữa',
      ne: 'Trên bên phải',
      w: 'Giữa bên trái',
      center: 'Chính giữa',
      e: 'Giữa bên phải',
      sw: 'Dưới bên trái',
      s: 'Dưới giữa',
      se: 'Dưới bên phải',
    },
    apply: 'Đổi khung',
  },

  editor: {
    untitled: 'Chưa đặt tên',
    backToHome: 'Về trang chủ',
    projectName: 'Tên project',
    workspaceLabel: 'Vùng làm việc',
    canvasLabel: 'Khung vẽ {width} × {height} pixel. Dùng chuột, bút hoặc cảm ứng để vẽ.',
    statusReady: 'Sẵn sàng',
    toolsLabel: 'Công cụ',
    optionsLabel: 'Tùy chọn công cụ',
    missingTitle: 'Không tìm thấy project',
    missingBody:
      'Project đã bị xóa, nằm trong thùng rác, hoặc chỉ có ở trình duyệt khác. Hãy mở lại từ trang chủ.',
    unsavedWarning: 'Ảnh chưa được lưu. Rời trang sẽ mất các thay đổi.',
    loading: 'Đang mở project…',
    renameLabel: 'Đổi tên project',
    moreActions: 'Thêm thao tác',
    corruptTitle: 'Không đọc được bản lưu của project',
    corruptBody:
      'Bản lưu hiện tại bị hỏng. Bạn có thể mở bản dự phòng (checkpoint) đã lưu lúc {time}.',
    corruptNoCheckpoint: 'Bản lưu hiện tại bị hỏng và không có bản dự phòng.',
    openCheckpoint: 'Mở bản dự phòng',
    failedTitle: 'Không mở được project',
    failedBody:
      'Thiết bị không đủ bộ nhớ hoặc dữ liệu không đọc được. Hãy đóng bớt tab khác rồi thử lại.',
    retry: 'Thử lại',
  },

  actions: {
    close: 'Đóng',
    undo: 'Hoàn tác',
    redo: 'Làm lại',
    undoNamed: 'Hoàn tác: {label}',
    redoNamed: 'Làm lại: {label}',
    copy: 'Copy ảnh',
    exportPng: 'Xuất PNG',
    export: 'Xuất ảnh…',
    exportShort: 'Xuất',
    save: 'Lưu ngay',
    copied: 'Đã copy ảnh vào clipboard',
    copyDownloaded: 'Trình duyệt không cho ghi ảnh vào clipboard — đã tải file PNG xuống',
    pasteInternalFallback:
      'Không đọc được ảnh clipboard hệ thống — đang dán bản đã copy trong app.',
    exported: 'Đã xuất {file}',
    exportFailed: 'Không xuất được ảnh',
    copiedSelection: 'Đã copy vùng chọn',
    cutSelection: 'Đã cắt vùng chọn',
    pasteFailed: 'Không dán được ảnh này',
    dropImage: 'Thả ảnh để thêm thành layer mới',
  },

  layers: {
    background: 'Nền',
    numbered: 'Lớp {n}',
    annotationNumbered: 'Chú thích {n}',
    copyName: '{name} (bản sao)',
    listLabel: 'Danh sách layer, layer trên cùng ở đầu',
    raster: 'Layer ảnh',
    vector: 'Layer chú thích',
    empty: 'trống',
    show: 'Hiện layer',
    hide: 'Ẩn layer',
    lock: 'Khóa layer',
    unlock: 'Mở khóa layer',
    lockedBadge: 'Đã khóa',
    hiddenBadge: 'Đang ẩn',
    alphaLock: 'Khóa vùng trong suốt',
    alphaLockHint: 'Chỉ vẽ lên chỗ đã có pixel',
    opacity: 'Độ mờ',
    blend: 'Hòa trộn',
    blendLabel: 'Chế độ hòa trộn của layer',
    blendModes: {
      normal: 'Bình thường',
      multiply: 'Nhân (Multiply)',
      screen: 'Sáng lên (Screen)',
      overlay: 'Phủ (Overlay)',
      darken: 'Tối hơn',
      lighten: 'Sáng hơn',
      'color-dodge': 'Color Dodge',
      'color-burn': 'Color Burn',
      'hard-light': 'Hard Light',
      'soft-light': 'Soft Light',
      difference: 'Hiệu (Difference)',
      exclusion: 'Loại trừ (Exclusion)',
      hue: 'Sắc màu (Hue)',
      saturation: 'Độ bão hòa',
      color: 'Màu (Color)',
      luminosity: 'Độ sáng (Luminosity)',
    },
    add: 'Thêm layer',
    addAnnotation: 'Thêm layer chú thích',
    duplicate: 'Nhân bản layer',
    remove: 'Xóa layer',
    mergeDown: 'Gộp xuống layer dưới',
    mergeVisible: 'Gộp các layer đang hiện',
    flatten: 'Làm phẳng ảnh (Flatten)',
    rasterize: 'Rasterize layer chú thích',
    more: 'Thao tác khác',
    rename: 'Đổi tên layer',
    renameLabel: 'Tên layer',
    moveUp: 'Đưa layer lên trên',
    moveDown: 'Đưa layer xuống dưới',
    selectNamed: 'Layer {name}',
    activeChanged: 'Đang làm việc trên layer {name}',
    dragInstructions:
      'Nhấn Space hoặc Enter để nhấc layer, mũi tên lên/xuống để di chuyển, Space hoặc Enter để thả, Esc để hủy.',
    dragStart: 'Đã nhấc layer {name}.',
    dragOver: 'Layer {name} ở vị trí {position} trên {total}.',
    dragEnd: 'Đã thả layer {name} ở vị trí {position} trên {total}.',
    dragCancel: 'Đã hủy di chuyển layer {name}.',
    flattenHiddenNote: 'Layer đang ẩn sẽ bị bỏ khi làm phẳng (có thể hoàn tác).',
  },

  panel: {
    label: 'Bảng Layer và Lịch sử',
    screenshotLabel: 'Bảng Làm đẹp và Lịch sử',
    layersTab: 'Layer',
    historyTab: 'Lịch sử',
    beautifyTab: 'Làm đẹp',
    collapse: 'Thu gọn bảng bên phải',
    expand: 'Mở bảng bên phải',
  },

  beautify: {
    title: 'Làm đẹp ảnh',
    enable: 'Khung làm đẹp',
    enabledHint: 'Áp dụng khi Copy, Tải xuống và Xuất ảnh.',
    disabledHint: 'Thêm nền, khoảng viền, bo góc và bóng quanh ảnh trước khi chia sẻ.',
    background: 'Nền',
    padding: 'Khoảng nền',
    radius: 'Bo góc',
    shadow: 'Bóng đổ',
    backgrounds: {
      ocean: 'Đại dương',
      sunset: 'Hoàng hôn',
      mint: 'Bạc hà',
      peach: 'Đào',
      night: 'Đêm',
      paper: 'Xám nhạt',
      white: 'Trắng',
      transparent: 'Trong suốt',
    },
  },

  screenshot: {
    copy: 'Copy',
    download: 'Tải xuống',
    toPaint: 'Chế độ Paint đầy đủ',
    toPaintShort: 'Paint đầy đủ',
    toScreenshot: 'Chế độ Screenshot',
    modeBadge: 'Screenshot',
  },

  presets: {
    arrowBold: 'Mũi tên đỏ nổi bật',
    arrowThin: 'Mũi tên mảnh',
    arrowDashed: 'Mũi tên nét đứt',
    arrowDouble: 'Mũi tên hai đầu',
    frameRed: 'Khung đỏ',
    frameRounded: 'Khung bo góc có bóng',
    frameDashed: 'Khung nét đứt',
    frameTint: 'Khung tô nhạt',
    textCallout: 'Chữ chú thích có viền',
    textLabel: 'Nhãn nền đỏ',
    textNote: 'Ghi chú nền vàng',
    textTitle: 'Tiêu đề lớn',
  },

  historyPanel: {
    listLabel: 'Các bước đã làm, bước cũ ở đầu',
    original: 'Trạng thái lúc mở',
    oldest: '… trạng thái cũ nhất còn giữ',
    trimmed: 'Các bước cũ hơn đã được giải phóng để tiết kiệm bộ nhớ.',
    empty: 'Chưa có thao tác nào.',
    jumpTo: 'Quay về sau bước: {label}',
    jumpToOriginal: 'Quay về trạng thái lúc mở',
    undone: 'đã hoàn tác',
    note: 'Lịch sử chỉ giữ trong phiên làm việc — đóng project là mất.',
  },

  history: {
    brush: 'Nét cọ',
    eraser: 'Tẩy',
    pencil: 'Nét bút chì',
    fill: 'Tô màu',
    addObject: 'Thêm hình',
    addArrow: 'Thêm mũi tên',
    alignObjects: 'Căn chỉnh đối tượng',
    addHighlight: 'Đánh dấu',
    addRedact: 'Che thông tin',
    addStep: 'Thêm số thứ tự',
    addSpotlight: 'Thêm Spotlight',
    addMagnifier: 'Thêm vùng phóng to',
    beautify: 'Làm đẹp ảnh',
    addText: 'Thêm chữ',
    editText: 'Sửa chữ',
    moveObject: 'Di chuyển đối tượng',
    transformObject: 'Đổi hình đối tượng',
    rotateObject: 'Xoay đối tượng',
    styleObject: 'Đổi kiểu đối tượng',
    deleteObject: 'Xóa đối tượng',
    bringToFront: 'Đưa lên trên cùng',
    sendToBack: 'Đưa xuống dưới cùng',
    addLayer: 'Thêm layer',
    addAnnotationLayer: 'Thêm layer chú thích',
    duplicateLayer: 'Nhân bản layer',
    deleteLayer: 'Xóa layer',
    moveLayer: 'Đổi thứ tự layer',
    renameLayer: 'Đổi tên layer',
    layerVisibility: 'Ẩn/hiện layer',
    layerLock: 'Khóa/mở khóa layer',
    layerAlphaLock: 'Khóa vùng trong suốt',
    layerOpacity: 'Độ mờ layer',
    layerBlend: 'Chế độ hòa trộn',
    layerProps: 'Thuộc tính layer',
    mergeDown: 'Gộp xuống',
    mergeVisible: 'Gộp layer đang hiện',
    flatten: 'Làm phẳng ảnh',
    rasterize: 'Rasterize layer',
    moveSelection: 'Di chuyển vùng chọn',
    duplicateSelection: 'Nhân bản vùng chọn',
    transformSelection: 'Biến đổi vùng chọn',
    deleteSelection: 'Xóa vùng chọn',
    fillSelection: 'Tô vùng chọn',
    cut: 'Cắt',
    paste: 'Dán',
    crop: 'Cắt xén ảnh',
    trim: 'Cắt bỏ vùng trong suốt',
    resize: 'Đổi kích thước ảnh',
    canvasSize: 'Đổi kích thước khung',
    rotate: 'Xoay ảnh',
    flip: 'Lật ảnh',
    rotateLayer: 'Xoay layer',
    flipLayer: 'Lật layer',
    gradient: 'Chuyển màu',
    filter: 'Bộ lọc',
    brightnessContrast: 'Độ sáng/Tương phản',
    hueSaturation: 'Sắc độ/Độ bão hòa',
    grayscale: 'Đen trắng',
    invert: 'Đảo màu',
    sepia: 'Sepia',
    blur: 'Làm mờ',
    sharpen: 'Làm sắc nét',
    pixelate: 'Khảm điểm ảnh',
  },

  tools: {
    select: 'Chọn và di chuyển',
    'marquee-rect': 'Chọn hình chữ nhật',
    'marquee-ellipse': 'Chọn hình elip',
    lasso: 'Chọn tự do (Lasso)',
    wand: 'Đũa thần',
    crop: 'Cắt xén',
    pencil: 'Bút chì',
    brush: 'Cọ vẽ',
    eraser: 'Tẩy',
    bucket: 'Tô màu',
    gradient: 'Chuyển màu (Gradient)',
    eyedropper: 'Lấy màu',
    rect: 'Hình chữ nhật',
    ellipse: 'Hình elip',
    line: 'Đường thẳng',
    arrow: 'Mũi tên',
    polygon: 'Đa giác',
    text: 'Chữ',
    highlight: 'Bút dạ quang',
    redact: 'Che thông tin',
    step: 'Số thứ tự',
    spotlight: 'Spotlight',
    magnifier: 'Phóng to vùng',
    pan: 'Di chuyển khung nhìn',
    zoom: 'Thu phóng',
    shapes: 'Hình khối (nhớ hình dùng gần nhất)',
    marquee: 'Chọn vùng (nhấn lại để đổi chữ nhật/elip)',
    fillTools: 'Tô màu (nhấn lại để đổi Tô màu/Gradient)',
    fillVariants: 'Các kiểu tô',
    selectVariants: 'Các kiểu chọn',
    shapeVariants: 'Các hình khối',
    focusVariants: 'Làm nổi bật (Spotlight, phóng to vùng)',
    groupSelect: 'Chọn',
    groupDraw: 'Vẽ',
    groupShape: 'Hình',
    groupAnnotate: 'Chữ và chú thích',
    groupView: 'Khung nhìn',
    selected: 'Đã chọn công cụ {tool}',
  },

  toolOptions: {
    preset: 'Kiểu',
    presetRound: 'Tròn',
    presetSoft: 'Mềm',
    presetMarker: 'Marker',
    presetCalligraphy: 'Thư pháp',
    size: 'Cỡ',
    opacity: 'Độ mờ',
    hardness: 'Độ cứng',
    flow: 'Lưu lượng',
    smoothing: 'Làm mượt',
    pressureSize: 'Áp lực bút đổi cỡ nét',
    pressureOpacity: 'Áp lực bút đổi độ đậm',
    advanced: 'Tùy chọn nâng cao',
    tolerance: 'Dung sai',
    contiguous: 'Liền kề',
    sampleAll: 'Lấy mẫu mọi layer',
    expand: 'Nới vùng tô',
    strokeWidth: 'Nét',
    fill: 'Tô màu phụ',
    cornerRadius: 'Bo góc',
    dashed: 'Nét đứt',
    shadow: 'Bóng đổ',
    arrowHead: 'Đầu',
    headTriangle: 'Tam giác',
    headOpen: 'Mở',
    headNone: 'Không',
    bothEnds: 'Hai đầu',
    font: 'Font',
    fontInter: 'Inter',
    fontHand: 'Viết tay',
    fontMono: 'Mono',
    weight: 'Độ đậm chữ',
    weightRegular: 'Thường',
    weightSemibold: 'Vừa',
    weightBold: 'Đậm',
    align: 'Căn',
    alignLeft: 'Trái',
    alignCenter: 'Giữa',
    alignRight: 'Phải',
    italic: 'Chữ nghiêng',
    textBackground: 'Nền chữ',
    textOutline: 'Viền chữ',
    color: 'Màu',
    highlightYellow: 'Vàng',
    highlightGreen: 'Xanh lá',
    highlightBlue: 'Xanh dương',
    highlightPink: 'Hồng',
    highlightOrange: 'Cam',
    pencilHint: 'Bút chì vẽ từng pixel, không khử răng cưa.',
    panHint: 'Kéo để di chuyển. Giữ Space để dùng tạm khi đang ở công cụ khác.',
    zoomHint: 'Click để phóng to, Alt + click để thu nhỏ, kéo ngang để thu phóng liên tục.',
    selectHint:
      'Click để chọn, kéo để di chuyển, kéo khung để chọn nhiều. Double-click vào chữ để sửa.',
    eyedropperHint:
      'Click lấy màu chính, Shift + click lấy màu phụ. Ở công cụ vẽ, giữ Alt để lấy màu tạm thời.',
    redactHint: 'Kéo để che thông tin. Ảnh xuất ra không còn chứa pixel gốc dưới vùng che.',
    redactMode: 'Kiểu che',
    redactSolid: 'Tô kín',
    redactPixelate: 'Khảm',
    redactBlur: 'Làm mờ',
    blockSize: 'Cỡ ô',
    blurRadius: 'Độ mờ',
    redactBlurWarning: 'Làm mờ có thể bị khôi phục một phần — thông tin nhạy cảm nên dùng Tô kín.',
    notApplicable: 'Không áp dụng cho kiểu cọ này',
    redactBlurWarningShort: 'Có thể bị khôi phục',
    hintLabel: 'Cách dùng',
    stepSize: 'Cỡ',
    stepHint: 'Click để đặt số thứ tự · số tự tăng và tự đánh lại khi xóa.',
    spotlightShape: 'Hình',
    shapeRect: 'Chữ nhật',
    shapeEllipse: 'Elip',
    dim: 'Độ tối',
    spotlightHint: 'Kéo vùng cần làm nổi bật — phần còn lại tối đi.',
    magnifierZoom: 'Phóng to',
    magnifierHint: 'Kéo chọn vùng cần phóng to · kéo tâm bản phóng to để đặt chỗ khác.',
    stylePresets: 'Kiểu nhanh',
    polygonHint: 'Click thêm đỉnh · click đỉnh đầu để khép kín · double-click hoặc Enter để xong',
    selectionMode: 'Chế độ',
    modeReplace: 'Mới',
    modeAdd: 'Thêm',
    modeSubtract: 'Bớt',
    modeIntersect: 'Giao',
    feather: 'Làm mềm biên',
    antiAlias: 'Khử răng cưa',
    selectionHint:
      'Shift: thêm · Alt: bớt · Shift+Alt: giao · kéo trong vùng chọn để di chuyển (Alt: nhân bản)',
    wandHint: 'Click chọn vùng cùng màu · Shift: thêm · Alt: bớt',
    cropHint: 'Kéo khung hoặc handle · Enter hoặc double-click để cắt · Esc đặt lại',
    floatingHint: 'Kéo để di chuyển, handle để co giãn/xoay · Enter áp dụng · Esc hủy',
    objectLabel: 'Đối tượng đang chọn',
    objectsSelected: '{count} đối tượng',
    deleteObject: 'Xóa đối tượng',
    textEditing: 'Đang gõ chữ — Esc hoặc {shortcut} để xong',
    gradientKind: 'Kiểu',
    gradientLinear: 'Thẳng',
    gradientRadial: 'Tỏa tròn',
    toTransparent: 'Tới trong suốt',
    gradientHint:
      'Kéo từ điểm đầu tới điểm cuối · màu chính → màu phụ · Shift: góc 45° · chỉ trong vùng chọn',
  },

  colors: {
    fromImage: 'Màu từ ảnh',
    primary: 'Màu chính',
    secondary: 'Màu phụ',
    swap: 'Đổi màu chính và phụ',
    palette: 'Bảng màu',
    recent: 'Màu gần đây',
    hex: 'Mã màu',
    hexInvalid: 'Mã màu không hợp lệ (vd. #3B5BDB)',
    pickPrimary: 'Chọn màu chính {color}',
    setSecondaryHint: 'Click: màu chính · Chuột phải: màu phụ',
    editing: 'Đang chỉnh',
    picker: 'Bộ chọn màu',
    alpha: 'Độ đục',
    custom: 'Bảng màu của bạn',
    addCustom: 'Thêm màu đang chỉnh vào bảng',
    removeCustom: 'Chuột phải để xóa khỏi bảng',
    customEmpty: 'Bấm + để lưu màu hay dùng.',
    pickFromCanvas: 'Lấy màu từ ảnh',
  },

  zoom: {
    zoomIn: 'Phóng to',
    zoomOut: 'Thu nhỏ',
    level: 'Mức thu phóng',
    fit: 'Vừa khung',
    fill: 'Phủ kín',
    actual: '100%',
    percent: '{value}%',
    changed: 'Thu phóng {value}%',
  },

  status: {
    pointer: '{x}, {y} px',
    documentSize: '{width} × {height} px',
    memory: 'Bộ nhớ {value}%',
    selection: 'Vùng chọn {width} × {height}',
    floating: 'Đang di chuyển vùng chọn',
    busy: 'Đang xử lý ảnh…',
    memoryHint:
      'Bộ nhớ ước lượng đang dùng: {used} / {total}. Gần đầy thì một số thao tác sẽ bị từ chối.',
  },

  notices: {
    'memory.refused':
      'Không đủ bộ nhớ cho thao tác này. Hãy gộp bớt layer, giảm kích thước ảnh hoặc đóng project khác.',
    'memory.layersFull':
      'Các layer đã dùng hết phần bộ nhớ dành cho ảnh. Hãy gộp (Merge Down, Gộp các layer đang hiện) hoặc làm phẳng ảnh để giải phóng.',
    'memory.layersHigh':
      'Các layer đã dùng gần hết phần bộ nhớ dành cho ảnh. Nên gộp bớt layer hoặc làm phẳng ảnh.',
    'document.tooLarge': 'Ảnh quá lớn so với giới hạn của thiết bị này.',
    'layer.locked': 'Layer đang bị khóa.',
    'layer.hidden': 'Layer đang ẩn — hãy hiện layer trước khi vẽ.',
    'layer.mergeBackdrop':
      'Tổ hợp độ mờ, hòa trộn hoặc hiệu ứng này cần nền bên dưới — hãy dùng Gộp các layer hiện để giữ đúng ảnh.',
    'layer.limit': 'Project đã đạt giới hạn 200 layer — hãy gộp hoặc xóa layer trước khi thêm.',
    'layer.notRaster': 'Không vẽ pixel được trên layer chú thích.',
    'layer.noRasterBelow': 'Không có layer ảnh nào bên dưới để dùng.',
    'fill.failed': 'Không tô được vùng này.',
    'document.readOnly': 'Project đang được sửa ở tab khác — tab này chỉ xem được.',
    'selection.empty': 'Chưa có vùng chọn.',
    'image.nothingToTrim': 'Không có vùng trong suốt nào quanh ảnh để cắt bỏ.',
    'image.failed': 'Không biến đổi được ảnh — ảnh vẫn giữ nguyên.',
    'filter.notRaster': 'Bộ lọc chỉ áp dụng cho layer ảnh — hãy chọn layer ảnh trong panel Layers.',
    'filter.empty': 'Layer không có pixel nào để điều chỉnh.',
    'filter.failed': 'Không áp dụng được bộ lọc — ảnh vẫn giữ nguyên.',
    'filter.open': 'Đang mở bảng điều chỉnh — hãy Áp dụng hoặc Hủy trước.',
    'output.pending':
      'Hãy kết thúc thao tác hoặc Áp dụng/Hủy điều chỉnh trước khi lưu, copy hay xuất.',
    'layer.redactionProtected':
      'Layer có vùng che: hãy dùng Gộp các layer hiện để giữ vùng che an toàn.',
  },

  filters: {
    menu: 'Điều chỉnh',
    menuLabel: 'Điều chỉnh màu và bộ lọc',
    adjustGroup: 'Điều chỉnh',
    filterGroup: 'Bộ lọc',
    brightnessContrast: 'Độ sáng/Tương phản…',
    hueSaturation: 'Sắc độ/Độ bão hòa…',
    grayscale: 'Đen trắng',
    invert: 'Đảo màu',
    sepia: 'Sepia…',
    blur: 'Làm mờ…',
    sharpen: 'Làm sắc nét…',
    pixelate: 'Khảm điểm ảnh…',
    titles: {
      brightnessContrast: 'Độ sáng/Tương phản',
      hueSaturation: 'Sắc độ/Độ bão hòa',
      grayscale: 'Đen trắng',
      invert: 'Đảo màu',
      sepia: 'Sepia',
      blur: 'Làm mờ',
      sharpen: 'Làm sắc nét',
      pixelate: 'Khảm điểm ảnh',
    },
    params: {
      'brightness.amount': 'Độ sáng',
      'contrast.amount': 'Tương phản',
      'hue.degrees': 'Sắc độ',
      'saturation.amount': 'Độ bão hòa',
      'sepia.amount': 'Cường độ',
      'blur.radius': 'Bán kính',
      'sharpen.amount': 'Mức độ',
      'sharpen.radius': 'Bán kính',
      'pixelate.size': 'Cỡ ô',
    },
    units: { percent: '%', degrees: '°', px: 'px' },
    panelLabel: 'Bảng điều chỉnh',
    selectionNote: 'Chỉ tác động trong vùng chọn.',
    compare: 'Giữ để xem ảnh gốc',
    compareShort: 'So sánh',
    reset: 'Đặt lại',
    apply: 'Áp dụng',
    cancel: 'Hủy',
    applying: 'Đang áp dụng… {percent}%',
    applyingLabel: 'Tiến trình áp dụng bộ lọc',
    stop: 'Dừng',
  },

  menu: {
    canvasLabel: 'Menu khung vẽ',
    objectLabel: 'Menu đối tượng',
    delete: 'Xóa',
    bringToFront: 'Đưa lên trên cùng',
    sendToBack: 'Đưa xuống dưới cùng',
    deselect: 'Bỏ chọn',
    selectionLabel: 'Menu vùng chọn',
    imageMenu: 'Ảnh',
    imageMenuLabel: 'Biến đổi ảnh và vùng chọn',
    selectionGroup: 'Vùng chọn',
    copySelection: 'Copy',
    copyMerged: 'Copy ảnh đang thấy trong vùng chọn',
    cutSelection: 'Cắt',
    paste: 'Dán',
    selectAll: 'Chọn tất cả',
    invertSelection: 'Đảo vùng chọn',
    transformSelection: 'Co giãn, xoay vùng chọn',
    commitTransform: 'Áp dụng',
    cancelTransform: 'Hủy di chuyển',
    deleteSelection: 'Xóa vùng chọn',
    fillSelection: 'Tô vùng chọn bằng màu chính',
    redactSelection: 'Che thông tin trong vùng chọn',
    align: 'Căn chỉnh',
    alignLeft: 'Căn trái',
    alignCenterX: 'Căn giữa (ngang)',
    alignRight: 'Căn phải',
    alignTop: 'Căn trên',
    alignCenterY: 'Căn giữa (dọc)',
    alignBottom: 'Căn dưới',
    cropToSelection: 'Cắt xén theo vùng chọn',
    trim: 'Cắt bỏ vùng trong suốt',
    resize: 'Đổi kích thước ảnh…',
    canvasSize: 'Kích thước khung…',
    rotateCw: 'Xoay phải 90°',
    rotateCcw: 'Xoay trái 90°',
    rotate180: 'Xoay 180°',
    flipHorizontal: 'Lật ngang',
    flipVertical: 'Lật dọc',
    rotateSelectionCw: 'Xoay vùng chọn phải 90°',
    rotateSelectionCcw: 'Xoay vùng chọn trái 90°',
    flipSelectionHorizontal: 'Lật ngang vùng chọn',
    flipSelectionVertical: 'Lật dọc vùng chọn',
    layerTransform: 'Xoay, lật layer hiện tại',
    selectionRotateFlip: 'Xoay, lật vùng chọn',
    rotateLayerCw: 'Xoay layer phải 90°',
    rotateLayerCcw: 'Xoay layer trái 90°',
    rotateLayer180: 'Xoay layer 180°',
    flipLayerHorizontal: 'Lật ngang layer',
    flipLayerVertical: 'Lật dọc layer',
  },

  paintTarget: {
    title: 'Đây là layer chú thích',
    body: '{tool} vẽ pixel nên không vẽ thẳng lên chú thích (mũi tên, khung, chữ).',
    'new-layer': 'Vẽ trên layer mới',
    'new-layerHint': 'Chú thích vẫn giữ nguyên và sửa được.',
    'layer-below': 'Dùng layer ảnh bên dưới',
    'layer-belowHint': 'Tác động lên ảnh nằm dưới chú thích.',
    rasterize: 'Rasterize layer chú thích',
    rasterizeHint: 'Chú thích thành pixel và không sửa được như đối tượng nữa.',
    remember: 'Nhớ lựa chọn này',
    cancel: 'Hủy',
  },

  text: {
    editorLabel: 'Nhập chữ chú thích',
  },

  importErrors: {
    empty: 'File rỗng.',
    unsupported: 'Định dạng không được hỗ trợ. Hãy dùng PNG, JPG, WebP, GIF, BMP hoặc SVG.',
    fileTooLarge: 'File quá lớn (tối đa 50 MB).',
    dimensionsTooLarge: 'Ảnh quá lớn (tối đa 16384 px mỗi cạnh).',
    decodeFailed: 'Không đọc được ảnh — file có thể bị hỏng.',
    timeout: 'Giải mã ảnh quá lâu nên đã dừng.',
    noImageInClipboard: 'Clipboard không có ảnh. Hãy chụp màn hình rồi nhấn {shortcut} lại.',
    scaled: 'Ảnh lớn hơn giới hạn của thiết bị nên đã được thu nhỏ còn {width} × {height} px.',
  },

  common: {
    on: 'Bật',
    off: 'Tắt',
  },

  fileSave: {
    saveAs: 'Lưu ra file .paint…',
    fileType: 'Project Paint Online',
    saved: 'Đã lưu vào {file}',
    linked: 'Ctrl+S lưu vào {file}',
    pickFailed: 'Không mở được hộp chọn nơi lưu.',
    permissionDenied: 'Trình duyệt không cho ghi vào {file}. Hãy chọn "Lưu ra file .paint…" lại.',
    writeFailed: 'Không ghi được {file} — bản trong trình duyệt vẫn đã lưu.',
  },

  pwa: {
    updateReady: 'Có phiên bản mới của Paint Online.',
    reload: 'Lưu và tải lại',
    offlineReady: 'Paint Online đã sẵn sàng dùng cả khi mất mạng.',
    saveFailed:
      'Chưa lưu được công việc hiện tại. Hãy thử lưu lại hoặc tải bản sao .paint trước khi cập nhật.',
  },

  objectList: {
    title: 'Đối tượng ({count})',
    withText: '{kind}: {text}',
    withDetail: '{kind} ({detail})',
    step: '{kind} {n}',
  },

  palette: {
    open: 'Tìm lệnh',
    title: 'Command Palette',
    placeholder: 'Gõ để tìm lệnh, công cụ, bộ lọc, project…',
    empty: 'Không tìm thấy lệnh phù hợp.',
    groupTools: 'Công cụ',
    groupCommands: 'Lệnh',
    groupFilters: 'Điều chỉnh và bộ lọc',
    groupView: 'Khung nhìn',
    groupApp: 'Ứng dụng',
    groupProjects: 'Project gần đây',
    newImage: 'Tạo ảnh mới…',
    theme: 'Giao diện: {theme}',
    openProject: 'Mở {name}',
    disabledHint: 'Chưa dùng được lúc này',
  },

  shortcutsDialog: {
    title: 'Bảng phím tắt',
    description:
      'Phím tắt là lối tắt, không là lối duy nhất: mọi lệnh đều có trong menu hoặc Command Palette. Dấu / ngăn các phím cùng tác dụng — phím sau là dự phòng khi trình duyệt giành phím trước.',
    search: 'Tìm phím tắt…',
    empty: 'Không có phím tắt phù hợp.',
    groupTools: 'Công cụ',
    groupEdit: 'Chỉnh sửa',
    groupView: 'Khung nhìn',
    groupLayers: 'Layer',
    groupBrush: 'Màu, brush',
    groupApp: 'Ứng dụng',
    or: 'hoặc',
    sizeKeys: 'Tăng / giảm cỡ',
    hardnessKeys: 'Tăng / giảm độ cứng',
    nudge: 'Dịch đối tượng/vùng chọn 1 px',
    nudgeLarge: 'Dịch đối tượng/vùng chọn 10 px',
    holdSpace: 'Giữ để kéo khung nhìn',
    holdAlt: 'Giữ để lấy màu tạm thời',
    copy: 'Copy vùng chọn, hoặc cả ảnh khi không có vùng chọn',
    cut: 'Cắt vùng chọn',
    paste: 'Dán ảnh thành layer mới',
    wheelZoom: 'Phóng to/thu nhỏ quanh con trỏ',
    altDrag: 'Đổi cỡ (ngang) và độ cứng (dọc) của cọ',
    altDragKeys: 'Alt + kéo chuột phải',
    wheelKeys: 'Ctrl + lăn chuột',
  },

  settings: {
    title: 'Cài đặt',
    description: 'Cài đặt lưu trong trình duyệt này.',
    appearance: 'Giao diện',
    theme: 'Chủ đề màu',
    language: 'Ngôn ngữ',
    languageVi: 'Tiếng Việt',
    languageNote: 'Phiên bản này chỉ có tiếng Việt.',
    saving: 'Lưu trữ',
    autosave: 'Tự động lưu',
    autosaveHint:
      'Lưu 1,5 giây sau thay đổi cuối. Khi tắt, app vẫn lưu khi nhấn Ctrl+S, chuyển tab, rời project hoặc đóng tab.',
    autosaveOffWarning:
      'Đang tắt tự động lưu — các thay đổi chỉ được lưu khi nhấn Ctrl+S hoặc rời project.',
    persistence: 'Lưu trữ bền vững',
    persistenceGranted: 'Đã bật: trình duyệt sẽ không tự xóa dữ liệu khi thiếu dung lượng.',
    persistenceDenied:
      'Chưa bật: trình duyệt có thể xóa dữ liệu khi thiếu dung lượng. Hãy sao lưu file .paint cho project quan trọng.',
    persistenceUnknown: 'Trình duyệt này không hỗ trợ yêu cầu lưu trữ bền vững.',
    persistenceRequest: 'Yêu cầu lưu bền vững',
    storageUsage: 'Đã dùng {used} / {quota}',
    memory: 'Bộ nhớ',
    historyBudget: 'Bộ nhớ cho lịch sử hoàn tác',
    historyBudgetHint:
      'Phần ngân sách bộ nhớ ({total}) dành cho các bước hoàn tác. Nhiều hơn = hoàn tác được xa hơn trên ảnh lớn.',
    historyLow: 'Ít (10%)',
    historyNormal: 'Vừa (25%)',
    historyHigh: 'Nhiều (40%)',
    view: 'Khung nhìn',
    gridSize: 'Khoảng cách lưới',
    gridSizeValue: '{value} px',
    errorLog: 'Nhật ký lỗi',
    errorLogHint:
      'Lỗi chỉ được ghi trong trình duyệt này, không gửi đi đâu. Tải file nhật ký khi cần báo lỗi.',
    errorLogEmpty: 'Chưa ghi nhận lỗi nào.',
    errorLogCount: '{count} lỗi đã ghi',
    errorLogDownload: 'Tải nhật ký (JSON)',
    errorLogClear: 'Xóa nhật ký',
    errorLogCleared: 'Đã xóa nhật ký lỗi',
    about: 'Phiên bản {version}',
  },

  view: {
    menu: 'Xem',
    zen: 'Zen mode',
    zenExit: 'Thoát Zen mode',
    zenHint: 'Nhấn {key} hoặc nút này để hiện lại giao diện',
    zenOn: 'Đã ẩn giao diện (Zen mode)',
    zenOff: 'Đã hiện lại giao diện',
    fullscreen: 'Toàn màn hình',
    exitFullscreen: 'Thoát toàn màn hình',
    fullscreenFailed: 'Trình duyệt không cho bật toàn màn hình.',
    grid: 'Lưới',
    rulers: 'Thước đo',
    snap: 'Bám lưới',
    on: 'Bật {name}',
    off: 'Tắt {name}',
  },

  help: {
    title: 'Hướng dẫn sử dụng',
    short: 'Hướng dẫn',
    open: 'Mở hướng dẫn sử dụng',
    openApp: 'Mở Paint Online',
    openAppShort: 'Mở app',
    heroTitle: 'Bạn muốn làm gì với Paint Online?',
    heroBody:
      'Hướng dẫn từng bước cho mọi công cụ — từ dán ảnh chụp màn hình và chú thích trong vài giây tới vẽ nhiều layer và chỉnh ảnh.',
    search: 'Tìm trong hướng dẫn…',
    searchLabel: 'Tìm trong hướng dẫn',
    searchEmpty:
      'Không tìm thấy nội dung khớp “{query}”. Thử từ khác, ví dụ “che”, “layer”, “xuất”.',
    searchCount: '{n} kết quả',
    quickStart: 'Bắt đầu nhanh',
    categories: 'Chủ đề',
    topicsCount: '{n} bài',
    contents: 'Mục lục',
    onThisPage: 'Trong bài này',
    related: 'Bài liên quan',
    previous: 'Bài trước',
    next: 'Bài tiếp',
    readingTime: '{n} phút đọc',
    levels: { basic: 'Cơ bản', advanced: 'Nâng cao', tutorial: 'Thực hành' },
    callouts: {
      note: 'Lưu ý',
      tip: 'Mẹo',
      warning: 'Cảnh báo',
      important: 'Quan trọng',
    },
    figureZoom: 'Phóng to ảnh minh họa',
    figureNote: 'Ảnh chụp từ Paint Online phiên bản {version}',
    markersLabel: 'Chú thích hình',
    toolShortcut: 'Phím tắt {key}',
    noShortcut: 'không có phím tắt',
    shortcutsIntro:
      'Bảng dưới sinh trực tiếp từ phím tắt của ứng dụng nên luôn khớp phiên bản bạn đang dùng.',
    shortcutKey: 'Phím',
    shortcutAction: 'Việc',
    notFoundTitle: 'Không tìm thấy bài hướng dẫn',
    notFoundBody:
      'Bài này có thể đã được đổi tên. Hãy tìm lại hoặc quay về trang chính của hướng dẫn.',
    home: 'Trang chính hướng dẫn',
    version: 'Hướng dẫn cho Paint Online {version}',
    menuToggle: 'Mở mục lục',
    menuClose: 'Đóng mục lục',
    backToTop: 'Lên đầu trang',
    fullGuide: 'Xem hướng dẫn chi tiết',
  },

  notFound: {
    title: 'Không tìm thấy trang',
    body: 'Đường dẫn này không trỏ tới project nào.',
    goHome: 'Về trang chủ',
  },

  errors: {
    unexpectedTitle: 'Đã xảy ra lỗi không mong muốn',
    unexpectedBody:
      'Giao diện gặp sự cố. Tải lại trang để tiếp tục — dữ liệu đã lưu không bị ảnh hưởng.',
    reload: 'Tải lại trang',
  },
} as const;

/** Cấu trúc từ điển: cùng khóa với `vi`, giá trị là chuỗi bất kỳ. */
type DeepStringify<T> = {
  readonly [K in keyof T]: T[K] extends string ? string : DeepStringify<T[K]>;
};
export type Messages = DeepStringify<typeof vi>;
